import { format, subMonths, isBefore } from "date-fns";

export function generateCompetenciasFromToday() {
  const result = [];

  const startDate = new Date(2026, 0, 1); // 01/2026
  let currentDate = new Date();

  while (!isBefore(currentDate, startDate)) {
    const key = format(currentDate, "MM/yyyy");

    const competencia = new Date(
      Date.UTC(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        1,
        3
      )
    ).toISOString();

    result.push({
      value: key,
      competencia,
    });

    currentDate = subMonths(currentDate, 1);
  }

  return result;
}